module.exports = __webpack_public_path__ + "static/media/circle- sports.1b08a619.svg";